<!--

Display's multi-line addresses. This component displays up to 5
address lines, a title, and a phone number. Phone is optional, but suggested.
This component has a "card" format, and includes borders (can be changed).
Useful when displaying many addresses.

Sample usage:

<address-card
title="County Court - Toronto"
address1="Judge Joseph M. Corabi"
address2="1007 Franklin Avenue"
address3="Toronto, OH 43964"
phone="(740) 537-2020"
></address-card>

A special "PhoneCard" component was designed for addresses that contain
multiple phone numbers. Sample usage:

<address-card
title="Children Services"
address1="240 John Scott Highway"
address2="Steubenville, OH 43952"
>
  <phone-card
  title="Agency"
  phone="(740) 264-5515"
  ></phone-card>
  <phone-card
  title="McCollough Children's Home"
  phone="(740) 264-5515"
  ></phone-card>
</address-card>

To change borders, you can disable it like this:

border="false"

Or change the color:

border="red"

-->

<template>
  <div class="card-container" v-bind:class="{'card-border': borderBool, [colorBorder]: borderBool}">
    <div class="card-title">
      {{title}}
    </div>
    <div>
      <ul>
        <li v-for="line in addressLines">
          {{line}}
        </li>
      </ul>
    </div>
    <div class="card-phone" v-bind:class="{colorPhone : true}">
      {{phone}}
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      addressLines: [],
      colorPhone: "text-light-blue-10",
      borderBool: true,
      colorBorder: ""
    }
  },
  props: ['title','address1','address2','address3','address4','address5',
          'phone-title','phone-color','phone','border'],
  created: function () {
    this.makeAddressLines()
    this.checkPhoneColor()
    this.checkBorder()
  },
  methods: {
    makeAddressLines: function() {
      if (this.address1 != null)
      {
        this.addressLines.push(this.address1)
      }

      if (this.address2 != null)
      {
        this.addressLines.push(this.address2)
      }

      if (this.address3 != null)
      {
        this.addressLines.push(this.address3)
      }

      if (this.address4 != null)
      {
        this.addressLines.push(this.address4)
      }

      if (this.address5 != null)
      {
        this.addressLines.push(this.address5)
      }
    },
    checkPhoneColor: function() {
      if (this.phoneColor != null && this.phoneColor != "") {
        this.colorPhone = "text-" + this.phoneColor
      }
    },
    checkBorder: function() {
      if (this.border != null && this.border != "") {
        if (this.border == "false") {
          //disable border
          this.borderBool = false
        } else {
          this.colorBorder = "border-" + this.border
        }
      }
    }
  }
}
</script>

<style scoped>
  .card-title {
    font-size: 1.25em;
    font-weight: bold;
    text-decoration: underline;
    padding:0;
  }

  .card-phone {
    font-weight: bold;
    padding:0.75em 0 0 0;
  }

  .card-container {
    margin: 1.0em 0;
    padding: 1.0em;
  }

  .card-container ul {
    padding: 0;
    margin: 0;
  }

  .card-container li {
    list-style-type: none;
  }

  .card-border {
    border-width: thin;
    border-style: solid;
  }

  .last-card {
    height: 0 !important;
    padding: 0 !important;
    margin: 0 0.5em 0 0.5em !important;
  }
</style>
